"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = translate;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _tinyInvariant = _interopRequireDefault(require("tiny-invariant"));

var _globalize = _interopRequireDefault(require("@sprinx/globalize"));

/**
 * Returns
 *
 * @param {string | Array<{ language: string, text: string }>} resource ResoureId nebo prekladovy slovnik. Pokud je
 *    nastaveni `acceptString === true` a `resource` neni typu `array` je vracena hodhota `resource`.
 * @param {Object} [options] Vlastnosti k resource, nebo nastaveni prekladove tabulky.
 * @param {boolean} [options.acceptString] Pokud je `true` je `resource` vzdy primy text nebo dictionary.
 *    Defaultne `false`.
 * @param {string} [options.defaultValue] Hodnota, ktera bude pouzita, pokud se preklad nenasel. Defaultne ''.
 * @param {string} [options.locale] Specificky `locale`. Defaultne jazyk `Globalize`.
 * @param {boolean} [options.silent] Do dont log error when translation is not found.
 *
 * @return {string} Preklad
 */
function translate(resource, options) {
  (0, _tinyInvariant.default)(resource, '`resource` is required for translation');

  var _locale$defaultValue$ = (0, _extends2.default)({
    locale: _globalize.default.locale().attributes.language,
    defaultValue: '',
    acceptString: false
  }, options),
      acceptString = _locale$defaultValue$.acceptString,
      defaultValue = _locale$defaultValue$.defaultValue,
      language = _locale$defaultValue$.language,
      pLocale = _locale$defaultValue$.locale,
      silent = _locale$defaultValue$.silent;

  var locale = language || pLocale;

  if (resource instanceof Error) {
    return resource.message;
  }

  if (typeof resource === 'string') {
    try {
      return acceptString ? resource : _globalize.default.messageFormatter(resource)(options);
    } catch (e) {
      if (!silent) console.error("translate: resource not found: '".concat(resource, "'\n"), e);
      return defaultValue || resource;
    }
  }

  var r = (Array.isArray(resource) ? resource : []).find(function (i) {
    return i.language === locale;
  });
  return (r === null || r === void 0 ? void 0 : r.text) || defaultValue;
}